import React from "react";

const Header = ({ title, className }) => {
  return (
    <div
      className={`d-lg-flex justify-content-between align-items-center ${className}`}
    >
      <h3 className="fw-bold mb-0">{title}</h3>
    </div>
  );
};

export default Header;
